export class InvoiceTableModel {
    constructor() {
        this.Id = "";
        this.DocumentType = 0;
        this.CustomerId = "";
        this.DocumentCode = "";
        this.InvoiceDate = "";
        this.Amount = "";
        this.DocumentLink = "";
        this.District = "";
    }
}

/*
export class InvoiceTableModel {
    constructor() {
        this.Id = "";
        this.OperationType = "";
        this.PostingDate = "";
        this.CustomerNumber = "";
        this.CustomerName = "";
        this.Cig = "";
        this.CustomerOrderDate = "";
        this.CustomerOrderNumber = "";
        this.Amount = "";
        this.VatAmount = "";
    }
}
 */